/**
 * ログインユーザーのグループ履歴。
 */
import { useMyGroups, useSpli } from "@spli/app-logic";
import { formatMoney } from "@spli/core";
import { Link, Navigate } from "react-router-dom";
import { EmptyState, ErrorView, LoadingView } from "../components/StatusViews.js";

export function HistoryPage() {
  const { user, initializing } = useSpli();
  const groupsQuery = useMyGroups();

  if (initializing) return <LoadingView />;
  if (!user) return <Navigate to="/login" replace />;
  if (groupsQuery.isPending) return <LoadingView />;
  if (groupsQuery.isError) return <ErrorView error={groupsQuery.error} />;

  const groups = groupsQuery.data;

  return (
    <section className="card">
      <h1 className="card__title">参加したグループ</h1>
      {groups.length === 0 ? (
        <EmptyState icon="empty-folder">
          まだ履歴がありません。
          <br />
          グループを開くとここに表示されます。
        </EmptyState>
      ) : (
        <div className="list">
          {groups.map((group) => (
            <Link key={group.id} className="list-item" to={`/g/${group.shareToken}`}>
              <span className="list-item__body">
                <span className="list-item__title">{group.name}</span>
                <span className="list-item__meta">
                  {group.memberCount}人 ・ 支出 {group.expenseCount} 件
                </span>
              </span>
              <span className="list-item__amount">
                {formatMoney(group.totalAmount, group.currency)}
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
